import React, { useState } from 'react';
import PropTypes from 'prop-types';
import withEnabledLocations from 'containers/withEnabledLocations';
import AccountCreationModal from 'components/AccountCreationModal';
import { LOCATION_DATA } from 'utils/constants';
import { determineRequiredAccountType } from 'utils/locations';
import { userShape } from 'utils/shapes';
import Checkmark from 'resources/checkmark_purple.png';
import ChevronUp from 'resources/chevron_up.png';
import './LocationPreferenceDropdown.css';

const LocationPreferenceDropdown = ({
  user,
  preferredLocation,
  onSelectLocation,
  onCloseSelectPreference,
  enabledLocations
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(preferredLocation);
  const [requiredAccountType, setRequiredAccountType] = useState(null);

  const locationData = preferredLocation && LOCATION_DATA[preferredLocation];

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
    setSelectedLocation(preferredLocation);
  };

  const handleLocationSelect = locationKey => {
    setSelectedLocation(locationKey);
  };

  const handleConfirm = () => {
    const requiredAccountType = determineRequiredAccountType(
      selectedLocation,
      user
    );

    if (requiredAccountType) {
      setRequiredAccountType(requiredAccountType);
    } else {
      onSelectLocation(selectedLocation);
      toggleDropdown();
      onCloseSelectPreference();
    }
  };

  const finalizeSelection = () => {
    onSelectLocation(selectedLocation);
    toggleDropdown();
    onCloseSelectPreference();
  };

  const renderAccountConversionModal = () => {
    if (selectedLocation && !!requiredAccountType) {
      return (
        <AccountCreationModal
          accountType={requiredAccountType}
          location={selectedLocation}
          onClose={() => setRequiredAccountType(null)}
          onFinalizeSelection={finalizeSelection}
        />
      );
    }
  };

  return (
    <div className="wstore-preference-dropdown">
      <button
        type="button"
        className="dropdown-header"
        onClick={toggleDropdown}
      >
        <img
          src={locationData?.image}
          alt={`Preferred Location: ${locationData?.name}`}
          className="location-image"
        />
        <span className="location-name">{locationData?.name}</span>
        <img
          src={ChevronUp}
          alt="Open Location Select Dropdown"
          className="chevron-up"
        />
      </button>
      {dropdownOpen && (
        <div className="location-dropdown-menu">
          <div className="dropdown-subtext">
            Select your Wind Creek WStore location.
          </div>
          {enabledLocations.map(location => (
            <button
              type="button"
              key={location.id}
              className={`location-dropdown-item ${
                selectedLocation === location.id ? 'selected' : ''
              }`}
              onClick={() => handleLocationSelect(location.id)}
            >
              <span className="location-name">{location.name}</span>
              {selectedLocation === location.id && (
                <img
                  src={Checkmark}
                  alt="Selected Location"
                  className="checkmark"
                />
              )}
            </button>
          ))}
          <div className="dropdown-actions">
            <button
              type="button"
              onClick={toggleDropdown}
              className="cancel-button"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleConfirm}
              className="confirm-button"
            >
              OK
            </button>
          </div>
        </div>
      )}
      {renderAccountConversionModal()}
    </div>
  );
};

LocationPreferenceDropdown.propTypes = {
  user: userShape,
  preferredLocation: PropTypes.string,
  onCloseSelectPreference: PropTypes.func,
  onSelectPreference: PropTypes.func,
  enabledLocations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      image: PropTypes.string,
      address: PropTypes.string,
      name: PropTypes.string,
      url: PropTypes.string,
      initiator: PropTypes.string,
      bookingUrl: PropTypes.string,
      assumeEnabled: PropTypes.bool
    })
  )
};

export default withEnabledLocations(LocationPreferenceDropdown);
